export class SizeController {
    observable;
    changeable;
    totalSectorsWidth;
    totalSectorsHeight;
    chartCount;
    truncWidthSquares;
    truncHeightSquares;
    ppcm;
    observer;
    parentHtmlWidth;
    constructor(settings) {
        this.observable = document.querySelector(settings.observable);
        this.changeable = document.querySelector(settings.changeable);
        this.totalSectorsWidth = settings.totalSectorsWidth;
        this.totalSectorsHeight = settings.totalSectorsHeight;
        this.chartCount = settings.chartCount;
        this.truncWidthSquares = settings.truncWidthSquares;
        this.truncHeightSquares = settings.truncHeightSquares;
        this.mainGraphHeightPercentage = settings.mainGraphHeightPercentage;
        this.rhythmGraphHeightPercentage = settings.rhythmGraphHeightPercentage;
        this.ppcm = this.getPpcm();
        this.parentHtmlWidth = 0;
        this.parentHtmlHeight = 0;
    }

    observe = () => {
        this.observer = new ResizeObserver(this.updateRootSize);
        this.observer.observe(this.observable);
    };

    updateRootSize = () => {
        const sizeRect = this.observable.getBoundingClientRect();
        const modalRect = this.changeable.getBoundingClientRect();
        const mainGraph = document.querySelector(".wholeGraph");
        const rhythmGraph = document.querySelector(".wholeGraphRhythm");
        const mainGraphSizeRect = document.querySelector(".wholeGraph").getBoundingClientRect();
        const rhythmGraphSizeRect = document.querySelector(".wholeGraphRhythm").getBoundingClientRect();

        const totalSectorsWidth = modalRect.width - mainGraphSizeRect.width + this.totalSectorsWidth;
        const totalSectorsHeight = modalRect.height - mainGraphSizeRect.height - rhythmGraphSizeRect.height;

        const centralWidth = sizeRect.width - totalSectorsWidth;
        const centralHeight = sizeRect.height - totalSectorsHeight;
        const mainGraphHeight = centralHeight * this.mainGraphHeightPercentage;
        const rhythmGraphHeight = centralHeight * this.rhythmGraphHeightPercentage - this.totalSectorsHeight;

        let widthSquareCount = Math.floor(centralWidth / (this.ppcm * this.truncWidthSquares));
        if (widthSquareCount % this.chartCount !== 0) {
            widthSquareCount--;
        }
        let mainGraphHeightInSquares = Math.floor(mainGraphHeight / (this.ppcm * this.truncHeightSquares));
        let rhythmGraphHeightInSquares = Math.floor(rhythmGraphHeight / (this.ppcm * this.truncHeightSquares));

        if (mainGraphHeightInSquares === 0) {
            mainGraphHeightInSquares += this.truncHeightSquares;
        }
        if (rhythmGraphHeightInSquares === 0) {
            rhythmGraphHeightInSquares += this.truncHeightSquares;
        }

        const heightSquareCount = mainGraphHeightInSquares + rhythmGraphHeightInSquares;
        const newMainGraphHeight = mainGraphHeightInSquares * (this.ppcm * this.truncHeightSquares);
        const newRhythmGraphHeight = rhythmGraphHeightInSquares * (this.ppcm * this.truncHeightSquares) + this.totalSectorsHeight;

        const newWidth = widthSquareCount * (this.ppcm * this.truncWidthSquares) + totalSectorsWidth;
        const newHeight = newMainGraphHeight + newRhythmGraphHeight + totalSectorsHeight;
        if (this.parentHtmlWidth === widthSquareCount && this.parentHtmlHeight === heightSquareCount) {
            return;
        }
        this.parentHtmlWidth = widthSquareCount;
        this.parentHtmlHeight = heightSquareCount;

        mainGraph.style.height = `${newMainGraphHeight}px`;
        rhythmGraph.style.height = `${newRhythmGraphHeight}px`;

        this.changeable.style.width = `${newWidth}px`;
        this.changeable.style.height = `${newHeight}px`;
    };

    stop = () => {
        this.observer.disconnect();
    };

    getPpcm = () => {
        const el = document.createElement("div");
        el.style.width = "1in";
        document.body.appendChild(el);
        const dpi = el.offsetWidth;
        document.body.removeChild(el);

        return dpi / 2.54;
    };
}
